// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__28FVu","consentsList":"PatientConsents_consentsList__2dNf3","consentsListEmpty":"PatientConsents_consentsListEmpty__2am4k"};